<div>
    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary"
                (click)="addCompanyPolicyType(0)" [disabled]="isDisabled">
                <i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add Policy':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Company Policy
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col" style="width: 5px;">#</th>
                        <th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
                        <th>Tile</th>
                    </tr>

                </thead>
                <tbody>
                    <tr *ngFor="let element of CompanyPolicyTypeData; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
                            <div class="text-center"><i
                                    (click)="addCompanyPolicyType(element['ESS_CompanyPolicyTypeMasterID'])"
                                    class="bi bi-pencil-square text-warning"></i></div>

                        </td>
                        <td> {{element['ESS_CompanyPolicyTypeTitle']}}</td>
                    </tr>
                </tbody>

            </table>
        </div>
    </div>
</div>